import React from 'react';

const SuccessDialog = () => {
	return (
		<div className="success-popup">
			<div>
				<div className="success-icon">
					<img
						alt="Drop-Box"
						height="100%"
						src="assets/images/awesome-icon.svg"
						style={{ alignSelf: 'center', marginTop: 5 }}
						width="100%"
					/>
				</div>
				<h1 className="popup-text">Your roster has been uploaded successfully</h1>
			</div>
		</div>
	);
};

export default SuccessDialog;
